// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1gEK2","label":"Category_label__2GPZt","content":"Category_content__2jHPc","header":"Category_header__oT2XG","location":"Category_location__3JTwf"};